import { BrandingStyle, CCTM, CCTM_demo, CCTM_item, CCTM_items, CCTM_link, CCTM_nav, CCTM_route, CCTM_subnav, NavLink, useBCMSModal, useCCTM, useModel, useRoute } from "@bcm-dev/bcms-vite";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle, useCustomAccordion } from "components/custom-ui/CustomAccordion";
import React, { useEffect, useState } from "react";
import { SVGAsset } from "res";
import "./styles.css";

const UtilityNavItemContext = React.createContext(null);
export default function MainNavView(props) {  
    const xml =  useCCTM(),
            menu = <CCTM nav-id="util" xml={xml} self={UtilityNavContainer}>
                        <CCTM_nav component={UtilityNavWrapper}/>                            
                        <CCTM_route component={UtilityNavItem}/>                  
                        <CCTM_link component={UtilityNavItem}/> 
                        <CCTM_item component={UtilityNavItem}/>   
                        <CCTM_items component={UtilityNavMenu}/>                     
                        <CCTM_demo component={UtilityNavItem}/> 
                         <CCTM_subnav component={Dropdown}/>              
                    </CCTM>;

  
  return menu;

}

function Dropdown(props){
    return <CCTM xml={props.currentNode} self={UtilityNavItem} data={props.data}>            
                       <CCTM_subnav component={Accordion}  /> 
                        <CCTM_route component={UtilityNavMenuItem} postRender={checkIfMessage}/>                  
                        <CCTM_link component={UtilityNavMenuItem} postRender={checkIfMessage}/> 
                        <CCTM_item component={UtilityNavMenuItem} postRender={checkIfMessage}/>
                        <CCTM_items component={MainNavWrapper}/>                   
                        <CCTM_demo component={UtilityNavMenuItem} postRender={checkIfMessage}/>                       
                    </CCTM>;
}
function Accordion(props){
    return <CCTM xml={props.currentNode} self={UtilityNavMenu} data={props.data}>            
                       <CCTM_subnav component={SubNavAccordion}  /> 
                        <CCTM_route component={UtilityNavMenuSubMenuItem}/>                  
                        <CCTM_link component={UtilityNavMenuSubMenuItem}/> 
                        <CCTM_item component={UtilityNavMenuSubMenuItem}/>
                        <CCTM_items component={SubNavItems}/>                   
                        <CCTM_demo component={UtilityNavMenuSubMenuItem}/>                       
                    </CCTM>;
}
function SubNavAccordion(props){
    return <CCTM xml={props.currentNode} self={UtilityNavSubMenu} data={props.data}>            
                       <CCTM_subnav component={SubNavAccordion}  /> 
                        <CCTM_route component={UtilityNavMenuSubMenuItem}/>                  
                        <CCTM_link component={UtilityNavMenuSubMenuItem}/> 
                        <CCTM_item component={UtilityNavMenuSubMenuItem}/>
                        <CCTM_items component={SubNavItems}/>                   
                        <CCTM_demo component={UtilityNavMenuSubMenuItem}/>                       
                    </CCTM>;
}
function checkIfMessage(component,data){
    if(data.id == "util_dropdown_messages"){
        return UtilityNavMenuMessagesItem
    }
    return component;
}

export function MainNavParent(props){
    return   <div>
        {props.children}
    </div>
        
     
}
export const useUtilityNavItemContext = () => React.useContext(UtilityNavItemContext);
export function MainNavWrapper(props){
    const [ state, setState ] = useState("");
  
    useEffect(() =>{}, [ state ]);
    return (
        <UtilityNavItemContext.Provider value={{ "state" : state, set: setState }}>
   {props.children}
      </UtilityNavItemContext.Provider>
      )
}
export function SubNavItems(props){
    return     <BrandingStyle style={{"backgroundColor" : "utility_subnav_bg_abi22"}} className="flex-container flex-vertical" >
        {props.children}
        </BrandingStyle>
        
     
}

export function UtilityNavWrapper(props){
    const { user } = useModel();
    return <>
            <UtilityNavBadge initials={ user.initials } />

            <UtilityNavItemContainer>
                {props.children}
            </UtilityNavItemContainer>
    </>
} 




/**
 * @name UtilityNavContainer
 * @function
 * @extends React.Component
 * @exported true
 * @description Main container for the Utility Nav
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      ...
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavContainer(props) {

    return (
  
        <div className="utility-nav-container set-width flex-container flex-horizontal align-center">
            { props.children }
        </div>
    
    );
}

/**
 * @name UtilityNavBadge
 * @function
 * @param {STRING} initials - The initials that should be shown
 * @extends React.Component
 * @exported true
 * @description The Badge that is shown in the Utility Nav
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      ...
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavBadge(props) {
    return (
        <BrandingStyle
            style={{ "backgroundColor": "nav_badge_bg_abi22", }}
            className="utility-nav-badge set-width text-center flex-container align-center">
            <div>
                <BrandingStyle style={{ "color": "nav_badge_text_abi22", }}>{props.initials ?? "[ABC]"}</BrandingStyle>
            </div>
        </BrandingStyle>
    );
}

/**
 * @name UtilityNavItemContainer
 * @function
 * @extends React.Component
 * @exported true
 * @description The container that wraps all UtilityNavItems
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      
 *      <UtilityNavItemContainer>
 *        ...
 *      </UtilityNavItemContainer>
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavItemContainer(props) {
    return (
        <div className="utility-nav-item-container flex-width flex-container flex-horizontal">
            { props.children }
        </div>
    );
}

/**
 * @name UtilityNavItem
 * @function
 * @param {STRING} label - The label that should be shown for the nav item
 * @param {STRING} route - The route that the nav item should go to on click
 * @param {STRING} data-point - The data point that should be added to the UtilityNavItem
 * @extends React.Component
 * @exported true
 * @description The nav item used in the UtilityNavItemContainer
 * @notes </br>
 * - If the nav item has children, the item will be switched to an accordion
 * - If the nav item has children, on click it would not route but open the accordion
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      
 *      <UtilityNavItemContainer>
 *        <UtilityNavItem label="First Item">
 *          ...
 *        </UtilityNavItem>
 * 
 *        <UtilityNavItem label="Second Item" route="/place" />
 *      </UtilityNavItemContainer>
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavItem(props) {
    const point = props["data-point"] ?props["data-point"] : props.datapoint ?? "";
    const [ state, setState ] = useState("");
   
    const label = props.label ?? "[username]";
let onClick =  false;
let to = props.to;
let modalID = props.to?.split("modal/"); 
    const { open } = useBCMSModal();
    
    const openMenuModal = evt => {
        const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";
    
        if(modalID && modalID[1]){
           open(MenuModalID, modalID[1]); 
        }
        
      }
    
    if(modalID && modalID[1]){
        to = "";
        onClick= ()=>{
         
            openMenuModal()
        };
    }
    if(props.onClick){
        to ="";
       
        onClick= ()=>{
         
            props.onClick()};
    }
    

    return (
     
//<SVGAsset id={props.asset.name} />
          <div className="utility-nav-item flex-width" data-point={ point }>
            {
                React.Children.count(props.children) > 0
                    ?   <CustomAccordion className="utility-nav-item-accordion">
                            <CustomAccordionToggle>
                            {props.asset_name?<SVGAsset id={props.asset_name} />:<></>}
                                <BrandingStyle style={{ 
                                                "color" : "utility_nav_text_abi22"
                                                }} element={
                                                <p onClick={ onClick  }>
                                                    { label }
                                                    <BrandingStyle style={{ 
                                                                    "fill": "utility_nav_text_abi22"
                                                                    }} element={<SVGAsset id="DownChevronIcon" />} />
                                                </p>} />
                            </CustomAccordionToggle>

                            <CustomAccordionContent>
                                { props.children }
                            </CustomAccordionContent>
                        </CustomAccordion>
                    
                    : <NavLink to={ onClick?"": props.to } onClick={ onClick } className={props["custom-class"]??""}>
                        <BrandingStyle style={{
                            "color" : "utility_nav_text_abi22"
                        }}  element={ <span>{ label }</span> } /> 
                      </NavLink>
                    
            }
          </div>

    );
}
export function CustomUtilityNavItem(props) {
    const point = props["data-point"] ?props["data-point"] : props.datapoint ?? "";

    const [ state, setState ] = useState("");
    const label = props.label ?? "[username]";
    let to = props.to;
    let onClick =  ()=>{};
    let modalID = props.to?.split("modal/"); 
        const { open } = useBCMSModal();
        
        const openMenuModal = evt => {
            const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";
        
            if(modalID && modalID[1]){
               open(MenuModalID, modalID[1]); 
            }
            
          }
        
        if(modalID && modalID[1]){
            to = "";
            onClick= ()=>{
             
                openMenuModal()
            };
        }
        if(props.onClick){
            to ="";
           
            onClick= ()=>{
             
                props.onClick()};
        }
        

    return (
        <NavLink to={ to } onClick={ onClick }>
                        <BrandingStyle style={{
                            "color" : "utility_nav_text_abi22"
                        }}  element={ <span>{ label }</span> } /> 
                      </NavLink>
                    
           
    );
}
/**
 * @name UtilityNavMenu
 * @function
 * @param {STRING} icon - The icon that should be shown in the header
 * @param {STRING} label - The label that should be shown in the header
 * @param {STRING} data-point - The data point that should be added to the UtilityNavMenu
 * @extends React.Component
 * @exported true
 * @description A sub accordion within the UtilityNavItem
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      
 *      <UtilityNavItemContainer>
 *        <UtilityNavItem label="First Item">
 *          <UtilityNavMenu icon="DownChevronIcon" label="Profile">
 *            <UtilityNavMenuItem />
 *          </UtilityNavMenu>
 *        </UtilityNavItem>
 * 
 *        <UtilityNavItem label="Second Item" route="/place" />
 *      </UtilityNavItemContainer>
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavMenu(props) {
    const point =props["data-point"] ?props["data-point"] : props.datapoint ?? "";
    const customClass =props["custom-class"] ?props["custom-class"] : "";
    const customClassForIcon = props["asset_custom-class"] ? { assetCustomClass: props["asset_custom-class"] } : {};
    
    return (
       
        <CustomAccordion data-point={ point }>
        <BrandingStyle style={{ 
                                                "color" : "utility_nav_text_abi22"
                                                }}> 
            <UtilityNavMenuHeader custom-class={customClass} { ...customClassForIcon } icon={props.asset_name? props.asset_name:false } label={ props.label } datapoint={point} />
</BrandingStyle>
            <CustomAccordionContent className="flex-container flex-vertical">
                { props.children }
            </CustomAccordionContent>
        </CustomAccordion>
       
    );
}

/**
 * @name UtilityNavMenuHeader
 * @function
 * @param {STRING} icon - The icon that should be shown
 * @param {STRING} label - The label that should be set
 * @exported true
 * @extends React.Component
 * @description The header item used in the UtilityNavMenu
 * @notes
 * - This is apart of the UtilityNavMenu, this should not need implemented anywhere else
 */
export function UtilityNavMenuHeader(props) {
    const { open, close } = useCustomAccordion();
    const { set, state } = useUtilityNavItemContext()

    const isOpen = state === props.label;
    const onClick = () =>{         
        set(isOpen ? "" : props.label)
    };
    const setAccordion = () => isOpen ? open() : close();
    const dataPointLabel = props["datapoint"] ? { "datapoint" : `${ props["datapoint"] }_Label` } : {};
    const dataPointChevronIcon = props["datapoint"] ? { "datapoint" : `${ props["datapoint"] }_Chevron_Icon` } : {};
    const customClassForIcon = props["assetCustomClass"] ? { className: props["assetCustomClass"] } : {};

    useEffect(() => setAccordion(), [ state ]);

    return (
        <div className={ `utility-nav-menu-header flex-container flex-horizontal align-top clickable ${ isOpen && "open" } `+ props["custom-class"] } onClick={ onClick }>
            <div className="set-width flex-container flex-horizontal align-center">
            {props.icon? <SVGAsset id={props.icon} { ...customClassForIcon } />:<></>}
            </div>
            <div className="flex-width">
                <span { ...dataPointLabel }>{ props.label }</span>
            </div>
            <div className="set-width text-right">
                <SVGAsset id={ isOpen ? "UpChevronIcon" : "DownChevronIcon" } { ...dataPointChevronIcon } />
            </div>
        </div>
    );
}
export function UtilityNavMenuSubMenuItem(props) {
    const point =props["datapoint"] ?props["datapoint"] : props.datapoint ?? "";
    const [ state, setState ] = useState("");
    let onClick =  ()=>{};
    let to = props.to;
    let modalID = props.to?.split("modal/"); 
        const { open } = useBCMSModal();
        
        const openMenuModal = evt => {
            const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";
        
            if(modalID && modalID[1]){
               open(MenuModalID, modalID[1]); 
            }
            
          }
        
        if(modalID && modalID[1]){
            to = "";
            onClick= ()=>{
             
                openMenuModal()
            };
        }
        if(props.onClick){
            to ="";
           
            onClick= ()=>{
             
                props.onClick()};
        }
        
    return (
        <NavLink className="utility-nav-menu-item clickable" to={ to } dataPoint={ point } onClick={onClick}>
            { props.label }
            </NavLink> 
    );
}


/**
 * @name UtilityNavMenuItem
 * @function
 * @param {STRING} label - The label to be shown for the menu item
 * @param {STRING} route - The route that the link should go to on click
 * @param {STRING} data-point - The data point that should be added to the UtilityNavMenuItem
 * @extends React.Component
 * @exported true
 * @description The menu item for the UtilityNavMenu
 * @notes
 * - If children exist, the menu item will be a toggable accordion
 * - If children exist, the route will be overwritten and not route
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      
 *      <UtilityNavItemContainer>
 *        <UtilityNavItem label="First Item">
 *          <UtilityNavMenu icon="DownChevronIcon" label="Profile">
 *            <UtilityNavMenuItem label="Item" route="/item" />
 * 
 *            <UtilityNavMenuItem>
 *              <UtilityNavMenuItem label="" route="" />
 *            </UtilityNavMenuItem>
 *          </UtilityNavMenu>
 *        </UtilityNavItem>
 * 
 *        <UtilityNavItem label="Second Item" route="/place" />
 *      </UtilityNavItemContainer>
 *    </UtilityNavContainer>
 *  );
 * }
 */

export function UtilityNavMenuItem(props) {
    const label = props.label ?? "[UtilityMenuLink]";
    const point = props["data-point"] ?props["data-point"] : props.datapoint ?? "";
    const hasChildren = React.Children.count(props.children) > 0;
    const customClass = props["custom-class"] ?props["custom-class"] : "";
    const navigate = useRoute();
    const [ state, setState ] = useState("");


    const onClick = () => {
        setState("");

        if(props.onClick instanceof Function) {
            props.onClick();
        }

        if(props.to !== undefined && !hasChildren) {
            navigate(props.to);
        }
    }

    return (
        <>
            {
                hasChildren
                    ?   <div className="utility-nav-menu-item clickable utility-nav-menu-accordion" data-point={ point }>
                            <CustomAccordion className="menu-nav-item-accordion" activeClass="sub-nav-open">
                                <CustomAccordionToggle>
                                    <UtilityNavMenuItemHeader label={ label } />
                                </CustomAccordionToggle>

                                <CustomAccordionContent className="flex-container flex-vertical">
                                    { props.children }
                                </CustomAccordionContent>
                            </CustomAccordion>
                        </div>
                    
                    :   <>
                
                  
                   
                  <div className={`utility-nav-menu-header messages-link flex-container flex-horizontal align-top clickable ${customClass}`} onClick={onClick} data-point={ point }>
                        <div className="set-width flex-container flex-horizontal align-center">
                            { props.asset_name && <SVGAsset id={props.asset_name} />}
                        </div>
                        <div className="flex-width">
                            <span>{props.label}</span>
                        </div>

                   </div> </>
                  
            }
        </>
    );
}

/**
 * @name UtilityNavMenuItemHeader
 * @function
 * @param {STRING} label - The label to be shown for the menu item
 * @param {BOOLEAN} useMainNavUI - A boolean that adds main nav ui (css) to the accordion. Only used for the main
 * nav since the functionality is the same but the ui is slightly different.
 * @extends React.Component
 * @exported true
 * @notes This should not be used besides in the UtilityNavMenuItem
 * @description Header component for the UtilityNavMenuItem so we can access accordion state
 */
export function UtilityNavMenuItemHeader(props) {
    const { state } = useCustomAccordion();
    const useMainNavUI = props.useMainNavUI ?? false;
    const className = props["custom-class"] ?? "";

    return (
        <div className={"flex-container flex-horizontal align-center " + className}>
            <div className="flex-width">{ props.label }</div>
            <div className="set-width chevron-container text-right">
                { !useMainNavUI && <SVGAsset id={ state ? "UpChevronIcon" : "DownChevronIcon" } /> }
                { useMainNavUI && <SVGAsset id={ "RightChevronIcon" } /> }
            </div>
        </div>
    );
}

/**
 * @name UtilityNavMenuMessagesItem
 * @function
 * @param {STRING} label - The label to be shown for the menu item
 * @param {BOOLEAN} useMainNavUI - A boolean that adds main nav ui (css) to the accordion. Only used for the main
 * nav since the functionality is the same but the ui is slightly different.
 * @extends React.Component
 * @exported true
 * @notes This should not be used besides in the UtilityNavMenuItem
 * @description Header component for the UtilityNavMenuItem so we can access accordion state
 */
 export function UtilityNavMenuMessagesItem(props) {
    const { state } = useCustomAccordion();
    const useMainNavUI = props.useMainNavUI ?? false;
    const className = props["custom-class"] ?? "";
    const icon = props.asset_name;
    const navigate = useRoute();
  
    return (
        <div className="utility-nav-menu-header messages-link flex-container flex-horizontal align-top clickable" onClick={() => {navigate(props.to)}} data-point={props.datapoint}>
        <div className="set-width flex-container flex-horizontal align-center">
            <SVGAsset id="EnvelopeIcon" />
        </div>
        <div className="flex-width">
            <span>{props.label}</span>
        </div>
        <div className="set-width text-center alert-bubble">
            <span>3</span>
        </div>
        </div>
    );
}
export function UtilityNavSubMenu(props) {
    const point =props["datapoint"] ?props["datapoint"] : props.datapoint ?? "";
 
    const [ state, setState ] = useState("");

    return (
        <div className="utility-nav-menu-item clickable utility-nav-menu-accordion">
           
            <CustomAccordion className="menu-nav-item-accordion utility-sub-nav-dropdown" activeClass="sub-nav-open" data-point={ point }>
                <CustomAccordionToggle>
                    <UtilityNavMenuItemHeader label={ props.label } />
                </CustomAccordionToggle>
                <CustomAccordionContent className="flex-container flex-vertical">
                    { props.children }
                </CustomAccordionContent>
            </CustomAccordion>
           
        </div>
    );
}
